import { LightTheme, createLightTheme, createDarkTheme } from 'baseui'
import { ThemePrimitives } from 'baseui/theme';

const normHex = (hex:any) => hex.length === 3 ? hex.split().map((e:any)=>e+e).join() : hex
const blackWhite = (hex:any) => parseInt(normHex(hex.replace('#', '')), 16) < 55*55*55 ? "#ffffff" : "#000000"
const blackYellow = (hex:any, inverse?: boolean) => {
  let ret = ["", ""];
  if(parseInt(normHex(hex.replace('#', '')), 16) > 144*144*144){
    ret[0] = "#000000"
    ret[1] = "#ffff00"
  } else {
    ret[0] = "#ffff00"
    ret[1] = "#000000"
  }
  return inverse ? ret[1] : ret[0]
}
const pxToRem = (px: string) => (parseInt(px.replace('px', '')) / 16) + 'rem'

const bwColors: Partial<ThemePrimitives> = Object.entries(LightTheme.colors).reduce((acc, [key, val]) => ({ ...acc, [key]: blackWhite(val) }), {})
const bwBorders = Object.entries(bwColors).filter(([key]) => key.includes('border') || key.includes('Border')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#fff' }), {})
const bwBg = Object.entries(bwColors).filter(([key]) => key.includes('notification') && key.includes('Background')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#000' }), {})
const bwText = Object.entries(bwColors).filter(([key]) => key.includes('notification') && key.includes('Text')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#fff' }), {})

const ybColors: Partial<ThemePrimitives> = Object.entries(LightTheme.colors).reduce((acc, [key, val]) => ({ ...acc, [key]: blackYellow(val) }), {})
const ybBorders = Object.entries(ybColors).filter(([key]) => key.includes('border') || key.includes('Border')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#ffff00' }), {})
const ybBg = Object.entries(bwColors).filter(([key]) => key.includes('notification') && key.includes('Background')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#000' }), {})
const ybText = Object.entries(bwColors).filter(([key]) => key.includes('notification') && key.includes('Text')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#ffff00' }), {})

const byColors: Partial<ThemePrimitives> = Object.entries(LightTheme.colors).reduce((acc, [key, val]) => ({ ...acc, [key]: blackYellow(val, true) }), {})
const byBorders = Object.entries(byColors).filter(([key]) => key.includes('border') || key.includes('Border')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#000' }), {})
const byBg = Object.entries(bwColors).filter(([key]) => key.includes('notification') && key.includes('Background')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#ffff00' }), {})
const byText = Object.entries(bwColors).filter(([key]) => key.includes('notification') && key.includes('Text')).reduce((acc, [key, val]) => ({ ...acc, [key]: '#000' }), {})

const remTypography = Object.entries(LightTheme.typography).reduce((acc, [key, val]) => ({ ...acc, [key]: {...val, fontSize: pxToRem(val.fontSize)} }), {})

const Light = createLightTheme({}, { typography: {...remTypography}})
const Dark = createDarkTheme({}, { typography: {...remTypography}})

const yb = createLightTheme(
    {
        ...ybColors,
       negative400: ybColors.primaryA,
       positive400: ybColors.primaryA
    },
    {
        typography: { ...remTypography },
        colors: {
            ...ybBorders,
            ...ybBg,
            ...ybText,
            inputPlaceholder: ybColors.primaryA,
            tabColor: ybColors.primaryA,
            buttonDisabledText: ybColors.primaryA,
            linkHover: ybColors.primaryA,
            menuFontDefault: ybColors.primaryA,
            tooltipText: ybColors.primaryA,
            buttonPrimaryActive: ybColors.primaryA,
            buttonPrimaryHover: ybColors.primaryA,
            buttonPrimarySelectedText: ybColors.primaryA,
            inputTextDisabled: ybColors.primaryA,
            tickMarkFillDisabled: ybColors.primaryB,
            tickFillDisabled: ybColors.primaryA,
            contentSecondary: ybColors.primaryA
        },
    },
);

const by = createLightTheme(
    {
        ...byColors,
        negative400: byColors.primaryA,
        positive400: byColors.primaryA
    },
    {
        typography: { ...remTypography },
        colors: {
            ...byBorders,
            ...byBg,
            ...byText,
            inputPlaceholder: byColors.primaryA,
            tabColor: byColors.primaryA,
            buttonDisabledText: byColors.primaryA,
            linkHover: byColors.primaryA,
            menuFontDefault: byColors.primaryA,
            tooltipText: byColors.primaryA,
            buttonPrimaryActive: byColors.primaryA,
            buttonPrimaryHover: byColors.primaryA,
            buttonPrimarySelectedText: byColors.primaryA,
            inputTextDisabled: byColors.primaryA,
            tickMarkFillDisabled: byColors.primaryB,
            tickFillDisabled: byColors.primaryA,
            contentSecondary: byColors.primaryA
        },
    },
);

const bw = createLightTheme(
    {
        ...bwColors,
        negative400: bwColors.primaryA,
        positive400: bwColors.primaryA
    },
    {
        typography: { ...remTypography },
        colors: {
            ...bwBorders,
            ...bwBg,
            ...bwText,
            inputPlaceholder: bwColors.primaryA,
            tabColor: bwColors.primaryA,
            buttonDisabledText: bwColors.primaryA,
            linkHover: bwColors.primaryA,
            menuFontDefault: bwColors.primaryA,
            tooltipText: bwColors.primaryA,
            buttonPrimaryActive: bwColors.primaryB,
            buttonPrimaryHover: bwColors.primaryB,
            buttonPrimarySelectedText: bwColors.primaryA,
            inputTextDisabled: bwColors.primaryA,
            tickMarkFillDisabled: bwColors.primaryB,
            tickFillDisabled: bwColors.primaryA,
            contentSecondary: bwColors.primaryA
        },
    },
);

export const THEMES: any = {
  LIGHT: Light,
  DARK: Dark,
  BLACK_WHITE: bw,
  YELLOW_BLACK: yb,
  BLACK_YELLOW: by
}

export const TYPOGRAPHY_SIZE  = {
  normal: "100%",
  large: '120%',
  xlarge: '150%'
}
